<div class="lms-toolbar__item">
  <div class="lms-toolbar__showItems">
    <span class="lms-toolbar__showItems--label">{{ 'actions.show' | translate }}:</span>
    <lms-select-dropdown
      [items]="items"
      [selectedItem]="limit"
      size="min"
      (change)="setItemsPerPage($event)"
    ></lms-select-dropdown>
  </div>
</div>
